import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  inject,
  observer,
  openViewTransparent
} from '../../../helper/devTools.js'

import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    // this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('APP GAME')
  }
  state = {
    messageTxt: "",
    lang:langM.en,
    language:'en',
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
    openViewTransparent(true)


    window.addEventListener('message', function (e) {
      if (e.data && e.data!="") {
        try {
          let d = JSON.parse(e.data)
          if (d.msgtp == "refresh") {
            console.log("触发iframe逻辑",d.content)
          }
        } catch (error) {
          // console.error(error)
        } 
      }
      
    }, false)
  

  }

    // 初始化/接口请求初始化
    RunOnStart = async (uid) => {
      // try {
      //   this.setState({
      //     uid: uid
      //   })
      //   let getUserInfo = await this.welfareStore.GetUserInfoWeb(uid)
      //   if (getUserInfo && getUserInfo.code == 0) {
      //     this.setState({
      //       userInfo: getUserInfo.res
      //     })
      //   }
      // } catch (error) {
      //   console.error(error)
      //   this.refs.msg.show("error")
      // }
    }

    post2 = async (msg) => {
      let map = {"msgtp":"popRecharge","content":"这里是发送的内容2"}
      window.parent.postMessage(JSON.stringify(map),'http://0.0.0.0:8000')
    }

    


  render() {
    return (
      <div className={`app-games-wrapper`}>
        <div onClick={this.post2.bind(this, "msg2")}>从iframe往顶层传送</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/test/iframe2/index.js